import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { completeLogin } from '../auth/auth';
import { Spinner, ErrorBanner, toMessage } from '../components/common';

// Handles the /auth/callback redirect from Cognito: exchanges the code for
// tokens (PKCE) then navigates on to the intended page.
export function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return; // StrictMode double-invoke guard: code is single-use.
    ran.current = true;
    (async () => {
      try {
        const returnTo = await completeLogin(window.location.search);
        navigate(returnTo, { replace: true });
      } catch (err) {
        setError(toMessage(err));
      }
    })();
  }, [navigate]);

  if (error) {
    return (
      <div className="public-wrap">
        <div className="card">
          <h1>Sign-in failed</h1>
          <ErrorBanner message={error} />
          <button onClick={() => navigate('/signin', { replace: true })}>Try again</button>
        </div>
      </div>
    );
  }
  return <Spinner label="Completing sign-in." />;
}
